// extracted by mini-css-extract-plugin
module.exports = {"access-back-office-title":"_2dRThULCWYm9Uc6ttemC-n","access-back-office-description":"rnYlXeWEPOascNV4hSvE7","partial-checked":"_1hZzVSxTSb7W2u5lZFncI-"};